const subheader = [
    {
        "key": "subheader.contribute_button",
        "string": "Contribute"
    },
    {
        "key": "subheader.home",
        "string": "Start"
    },
    {
        "key": "subheader.start",
        "string": "Knowledge platform"
    },
    {
        "key": "subheader.contribute",
        "string": "Contribute"
    },
    {
        "key": "subheader.confirm_account",
        "string": "Confirm account"
    },
    {
        "key": "subheader.reset_password",
        "string": "Reset password"
    },
    {
        "key": "subheader.knowledge_repository",
        "string": "Knowledge Repository"
    },
    {
        "key": "subheader.yellow_pages",
        "string": "Yellow pages"
    },
    {
        "key": "subheader.events",
        "string": "Events"
    }
]

export default subheader



// WEBPACK FOOTER //
// ./src/i18n/en/subheader/_subheader.js